import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Nessun prodotto ancora.',
  fields: {
    number: '#',
    image: 'Immagine',
    name: 'Nome',
    external_id: 'Rif. {{integration}}',
    price: 'Prezzo',
    prices: 'Prezzi',
    description: 'Descrizione',
    tags: 'Tag',
    status: 'Stato',
    product_type: 'Tipo',
    statuses: {
      good: 'Buono',
      bad: 'Cattivo',
      medium: 'Medio',
    },
    product_types: {
      packaged: 'Confezionato',
      prepared: 'Preparato',
    },
  },
  labels: {
    visible: 'Visibile nel menu',
    hidden: 'Tutti nascosti',
  },
  order_method_prices: {
    base: 'Base',
    [ORDER_METHODS.pickup]: 'Asporto',
    [ORDER_METHODS.delivery]: 'Consegna',
    [ORDER_METHODS.room_service]: 'Servizio al tavolo/camera',
  },
  buttons: {
    delete_products_one: 'Elimina prodotto',
    delete_products_other: 'Elimina prodotti',
    add_product: '+ Aggiungi prodotto',
    show_products: 'Mostra prodotti',
    hide_products: 'Nascondi prodotti',
    add: 'Aggiungi',
    edit: 'Modifica',
    duplicate: 'Duplica',
    history: 'Cronologia',
    delete: 'Elimina',
    delete_all: 'Elimina tutti',
  },
  toasts: {
    failed_to_duplicate_category: 'Duplicazione categoria non riuscita',
    category_duplicated_successfully: 'Categoria duplicata con successo',
    failed_to_duplicate_product: 'Duplicazione prodotto non riuscita',
    product_duplicated_successfully: 'Prodotto duplicato con successo',
    failed_to_delete_variant: 'Eliminazione variante non riuscita',
    variant_got_deleted: 'Variante eliminata',
    something_went_wrong: 'Qualcosa è andato storto',
  },
};
